<template>
  <div>
    <div class="title">
      <div id="notice">
        <h5>{{html_title}}使用说明:<br>
          <p v-html="html_note"></p>
        </h5>
      </div>
    </div>

    <pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

    </pre-base>

  </div>
</template>

<script>
  import api from '@/utils/type.js';
  import {
    Method_SelColumn
  } from '@/utils/loadhttpdata.js';

  // import {
  //   BackSpecial
  // } from "@/utils/localstore.js";

  import {
    base_decode
  } from "@/utils/base64.js";

  export default {
    components: {
      "pre-base": () => import("../auto/auto_view.vue")
    },
    data() {
      return {
        check_key: 'salaryother',
        init_data: '',

        html_title: '',
        html_note: '',

        row_id: '',
        item: ''

      };
    },
    mounted: function() {
      var that = this;
      this.$nextTick(function() {
        that.init_view();
      });
    },
    methods: {
      init_view: function() {
        var that = this;
        this.$nextTick(function() {

          that.fun_init();
          that.fun_note();
        });
      },
      fun_init: function() {
        this.init_data = '';
        this.init_data = JSON.stringify({
          "title": "个人工资其他单",
          "control": "salaryother",
          "step": "0",
          "isTwo": "1",
          "isTwoDetail":"1",
          "action_flag": "",
          "isFileMain":"1",
          "check_key": "salaryother",
          "sel_action": "exp_kq_salaryother",
          "upd_action": "base_salaryother",
          "detail_part":"0",
          "d_sel_action": "",
          "d_upd_action": "",
          "file_action": "salaryother",
          "p1": "kq",
          "p2": "salaryother",
          "p3": "",
          "parm_sel": [
            {
            "name": "月份",
            "val": "",
            "key": "s_month",
            "type": "month",
            "class": "long1",
            "x": "1"
          }, {
            "name": "部门",
            "val": "",
            "key": "d_id",
            "type": "select",
            "class": "long1",
            "sel_action": "",
            "sel_name": "",
            "x": "1"
          }, {
            "name": "员工",
            "val": "",
            "key": "u_id",
            "type": "select",
            "class": "long1",
            "sel_action": "data_base_salaryuser",
            "sel_name": "",
            "x": "1"
          }],
          "parm": [{
            "name": "月份",
            "val": "",
            "key": "s_month",
            "type": "month",
            "class": "long1",
            "p": "1",
            "w": "1",
            "r": "0",
            "x": "1"
          }, {
            "name": "员工",
            "val": "",
            "key": "u_id",
            "type": "select",
            "class": "long1",
            "sel_action": "data_base_salaryuser",
            "sel_name": "",
            "p": "1",
            "w": "1",
            "x": "1"
          }, {
            "name": "总金额",
            "val": "",
            "key": "amount",
            "type": "number",
            "class": "long1",
            "p": "1",
            "w": "1",
            "r": "0",
            "x": "2"
          }, {
            "name": "补发",
            "val": "",
            "key": "amount_in",
            "type": "number",
            "class": "long1",
            "p": "1",
            "w": "0",
            "r": "0",
            "x": "2"
          }, {
            "name": "扣款",
            "val": "",
            "key": "amount_out",
            "type": "number",
            "class": "long1",
            "p": "1",
            "w": "0",
            "r": "0",
            "x": "2"
          }, {
            "name": "备注",
            "val": "",
            "key": "note",
            "type": "textareaedit",
            "class": "long3",
            "p": "1",
            "w": "0",
            "r": "0",
            "x": "3"
          }],
          "parm_th": [
            {
            "name": "序号"
          }, {
            "name": "月份",
            "class": "long1"
          }, {
            "name": "部门",
            "class": "long1"
          }, {
            "name": "员工",
            "class": "long1"
          }, {
            "name": "总金额",
            "class": "long1"
          }, {
            "name": "补发",
            "class": "long1"
          }, {
            "name": "扣款",
            "class": "long1"
          },
          {
            "name": "备注",
            "class": "long3"
          },

          {
            "name": "状态"
          }, {
            "name": "修改人"
          },
          {
            "name": "附件"
          },
          {
            "name": "路径1"
          },
          {
            "name": "路径2"
          },
          {
            "name": "更新时间"
          }],
          "d_parm": [],
          "d_name": []
        });

      },
      fun_note: function() {
        this.$post(
          api.http_method, Method_SelColumn('base_note', 0, this.check_key)
        ).then(res => {
          res = JSON.parse(res);
          let temp_innerHtml = '';
          temp_innerHtml = base_decode(res.data);
          temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>");
          console.log(temp_innerHtml)
          this.html_note = temp_innerHtml;
        });

      },
      refresh_data: function() {
        var that = this;
        this.$nextTick(function() {
          that.$refs['mybase'].refresh_data();
        });
      },
      refresh_father: function(type, val, parm) {
        // console.log('type=' + type + ' val=' + val);
        // switch (type) {
        //   case 'father':
        //     // 弹出修改明细，修改主窗口信息
        //     this.refresh_data();
        //     break;
        //   default:
        //     // console.log('子组件刷新父组件传值=' + val);
        //     this.row_id = val;
        //     this.item = parm;
        //     break;
        // }
      }

    }
  };
</script>
